import { ClubListOrdering, useClubListQuery } from '~/pages/club/queries';
import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { DistrictBasicInfo } from './components/district-basic-info';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { ClubListTable } from '~/pages/club/list/club-list-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { useAuthentication } from '~/hooks/useAuthentication';
import { querySchema } from '~/pages/club/list/query-schema';
import { useDeleteDistrictMutation } from '../mutations';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Button } from '~/components/Button/Button';
import { insertOnCondition } from '~/utils/array';
import { useDistrictQuery } from '../queries';
import { useDialog } from '~/hooks/useDialog';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';
import { toast } from 'react-toastify';

export function Page() {
  const { id } = useParams(idParamSchema.parse);
  const { data } = useDistrictQuery(id);
  const { can } = useAuthentication();

  const { values } = useFilterForm(querySchema.parse);
  const { data: clubs, isLoading } = useClubListQuery({
    ordering: values.ordering as ClubListOrdering,
    district__id: id,
    page_size: values.pageSize,
    page: values.pageIndex,
  });

  const mutation = useDeleteDistrictMutation();
  const navigate = useNavigate();
  const dialog = useDialog();

  async function handleConfirm() {
    await toast.promise(mutation.mutateAsync(id), {
      success: 'Distriktet har tagits bort',
      pending: 'Tar bort distrikt...',
    });

    navigate('..');
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text={data.name} />

        <Button.Group neutral>
          <PageLayout.Context
            items={[
              ...insertOnCondition(
                <ContextMenu.Item label="Redigera" to="edit" key="edit" />,
                can('edit-district', id)
              ),
              ...insertOnCondition(
                <ContextMenu.Item label="Hantera rättigheter" to="admins" key="admins" />,
                can('list-district-admin', id)
              ),
              ...insertOnCondition(
                <ContextMenu.Item label="Ta bort" onClick={dialog.open} key="delete" danger />,
                can('delete-district', id)
              ),
            ]}
          />
        </Button.Group>
      </PageLayout.Header>

      <PageLayout.Section>
        <DistrictBasicInfo district={data} />
      </PageLayout.Section>

      <PageLayout.Section>
        <ClubListTable clubs={clubs?.results ?? []} isLoading={isLoading} />
        <Pagination count={clubs?.count} />
      </PageLayout.Section>

      <ConfirmDialog onConfirm={handleConfirm} isLoading={mutation.isPending} {...dialog} />
    </Fragment>
  );
}
